import { useTranslation } from 'react-i18next';

interface Props {
  titleKey?: string;
  hintKey?: string;
  actionKey?: string;
}

export default function ErrorFallback({
  titleKey = 'unexpectedError',
  actionKey = 'reload',
  hintKey = 'unexpectedErrorHint',
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card rounded-2xl p-8 w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <div
            className="w-20 h-20 rounded-2xl flex items-center justify-center"
            style={{
              background: 'rgba(239,68,68,0.15)',
              border: '2px solid rgba(239,68,68,0.4)',
            }}
          >
            <svg
              className="w-10 h-10 text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              />
            </svg>
          </div>
        </div>
        <p className="text-gray-300 mb-2">{t(titleKey)}</p>
        <p className="text-gray-400 text-sm mb-6">{t(hintKey)}</p>
        <button
          onClick={() => window.location.reload()}
          className="w-full py-3 rounded-lg text-white font-semibold"
          style={{ background: 'linear-gradient(135deg, #29ABE2, #8E98DF)' }}
        >
          {t(actionKey)}
        </button>
      </div>
    </div>
  );
}
